import { render } from "./notification-opt-in.vue?vue&type=template&id=dcdb9846&scoped=true"
import script from "./notification-opt-in.vue?vue&type=script&lang=js"
export * from "./notification-opt-in.vue?vue&type=script&lang=js"

import "./notification-opt-in.vue?vue&type=style&index=0&id=dcdb9846&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdb9846"]])

export default __exports__